export default __webpack_public_path__ + "static/media/new_dashboard_pastappointments_icon.ad8ea271.svg";